import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import GroupsIcon from '@mui/icons-material/Groups';
import {
  Grid,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Link,
  Button,
  Collapse,
  InputLabel,
} from '@material-ui/core';
import ApiIcon from '@mui/icons-material/Api';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MoneyIcon from '@mui/icons-material/Money';
import ExpandMore from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import { Alert, Box, Divider, Modal, Select, TextField } from '@mui/material';
import { makeStyles, Theme } from '@material-ui/core/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddIcon from '@mui/icons-material/Add';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
// import { Button } from '@mui/material';
import { InfoTooltip } from '../../Tooltips';
import { TooltipCard } from '../../Cards';
import {
  COLOR_PRIMARY_DARK,
  COLOR_PRIMARY_LIGHT,
  COLOR_PRIMARY,
  COLOR_RED,
  COLOR_RED_LIGHT,
  COLOR_BLACK,
  RoutesMap,
  exchangeRates,
} from 'src/const';
import LogoutIcon from '@mui/icons-material/Logout';
import { COLOR_BACKGROUND_1, COLOR_PRIMARY_1, COLOR_PRIMARY_2, KPI_CARD_COLOR } from 'src/colors';
import TourIcon from '@mui/icons-material/Tour';
import { TopRibbonPropTypes } from 'src/interfaces/iproptypes';
import { IconButton } from '@mui/material';
import userIcon from '../../../assets/userIcon.png';
import logoMobile from '../../../assets/logoMobile.jpg';
import { getTokenThunk } from '../../../../store/Auth/actions';
import CurrencyChangeMenu from '../../CurrencyChangeMenu';
import { callApi } from 'src/core/callApi';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import UnlockCTAButton from 'src/App/Components/Buttons/UnlockCTAButton';
import postOnSlack from 'src/core/postOnSlack';
import { clearApiCache } from 'src/utils/functions';
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
  },
  avatar: {
    width: 46,
    height: 46,
    cursor: 'pointer',
    [theme.breakpoints.down(900)]: {
      width: 46,
      height: 46,
    },
    backgroundColor: KPI_CARD_COLOR,
    color: '#ffff',
    // fontWeight: 'bold',
    fontSize: '25px',
  },
  chip: {
    marginTop: 4,
  },
  search: {
    '& input': {
      fontWeight: 500,
    },
  },
  customButtonActive: {
    background: COLOR_PRIMARY_DARK, //`radial-gradient(circle, hsla(189, 96%, 29%, 1) 0%, hsla(178, 100%, 38%, 1) 100%);`,
    borderRadius: 5,
    border: 0,
    color: 'white',
    height: 40,
    padding: '0 15px',
    boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
    '&:hover': {
      background: COLOR_PRIMARY_LIGHT,
    },
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
  },
  customButton: {
    background: COLOR_RED,
    borderRadius: 5,
    border: 0,
    color: 'white',
    height: 40,
    padding: '0 15px',
    boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
    '&:hover': {
      background: COLOR_RED_LIGHT,
    },
    [theme.breakpoints.down(1090)]: {
      fontSize: 12,
      '&:first-child': {
        marginLeft: -50,
      },
    },
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
  },
  logoMobile: {
    width: '7rem',
    objectFit: 'contain',
    height: 38,
    [theme.breakpoints.down(370)]: {
      width: '7rem',
      height: 30,
    },
  },
  mobileHeader: {
    [theme.breakpoints.up(900)]: {
      display: 'none',
    },
  },
  menuIcon: {
    color: COLOR_PRIMARY_DARK,
    fontSize: '2rem',
  },
  filterIconActive: {
    color: COLOR_PRIMARY_DARK,
    fontSize: '2rem',
  },
  filterIcon: {
    color: COLOR_RED,
    fontSize: '2rem',
  },
  creditsText: {
    color: COLOR_PRIMARY,
    fontSize: '1rem',
    marginRight: '20px',
    cursor: 'pointer',
  },
  iconButton: {
    padding: 3,
  },
  addCreditsBtn: {
    fontSize: 20,
    color: COLOR_PRIMARY_DARK,
    display: 'inline-block',
    marginBottom: '3px',
  },
  select: {
    width: 100,
    height: 40,
    marginRight: '20px',
  },
  takeTour: {
    background: 'linear-gradient(273.52deg, #7158E2 29.31%, #FF2079 97.77%)',
    alignItems: 'center',
    height: '40px',
    width: '10rem',
    marginRight: '10px',
    color: '#fff',
  },
  customMenu: {
    '& .MuiPaper-root': {
      borderRadius: '10px',
    },
  },
  subscribe: {
    marginRight: '10px',
    fontWeight: 'bold',
    cursor: 'pointer',
    color: '#000',
    '&:hover': {
      color: KPI_CARD_COLOR,
    },
  },
}));

const TopRibbon = ({
  logoutThunk,
  user,
  filterOpen,
  toggleDrawer,
  dashboardState,
  setSidebarOpen,
  filterApplied,
  handleMarketSidebarClick,
  setSubscriptionModalOpen,
  currency,
  setCurrency,
  setLoginModalOpen,
  matches,
  updateShowAppTour,
  sidebarOpen,
  SearchBar,
  isMobileSearchBarOpen,
  setIsMobileSearchBarOpen,
  handleSidebarListItemClick,
  centerCoord,
  setCenterCoord,
  address,
  setAddress,
}: TopRibbonPropTypes) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [helperEl, setHelperEl] = useState(null);
  const [showCredits, setShowCredits] = useState(false);
  const [userNameInitials, setUserNameInitials] = useState('');
  const [enterpriseDropDownOpen, setEnterpriseDropDownOpen] = useState(false);
  const [manageDropDownOpen, setManageDropDownOpen] = useState(false);
  const history = useHistory();
  const isLoggedIn = getTokenThunk()();
  const handleClick = ({ currentTarget }) => {
    setAnchorEl(currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEnterpriseDropdownClick = () => {
    setEnterpriseDropDownOpen(!enterpriseDropDownOpen);
  };

  const handleManageDropdownClick = () => {
    setManageDropDownOpen(!manageDropDownOpen);
  };

  const handleHelperClick = ({ currentTarget }) => {
    setHelperEl(currentTarget);
  };
  const handleHelperClose = () => {
    setHelperEl(null);
  };

  const handleLoginLogout = async () => {
    if (isLoggedIn) {
      logoutThunk();
      await clearApiCache();
      history.push(RoutesMap.Home);
    } else {
      localStorage.setItem('estimatorCoords', JSON.stringify(centerCoord));
      localStorage.setItem('estimatorAddress', address);
      setLoginModalOpen(true);
    }
  };

  const openSettings = () => {
    handleMarketSidebarClick('settings');
  };

  let userName = user && user.userName;
  if (!userName) {
    userName = 'Trial';
  }

  const handleSubscriptionModalOpen = () => {
    setSubscriptionModalOpen(true);
  };

  const changeCurrency = event => {
    setCurrency(event.target.value);
  };

  const getUserInitials = name => {
    const nameArray = name.split(' ');
    if (nameArray.length === 1) {
      return nameArray[0].slice(0, 2).toUpperCase();
    } else if (nameArray.length > 1) {
      const firstNameInitial = nameArray[0][0]?.toUpperCase();
      const lastNameInitial = nameArray[nameArray.length - 1][0]?.toUpperCase();
      return `${firstNameInitial}${lastNameInitial ? lastNameInitial : ''}`;
    } else {
      return '';
    }
  };

  useEffect(() => {
    if (user.userName != 'Trial') {
      let userNameInitials = getUserInitials(user.userName);
      setUserNameInitials(userNameInitials);
    }

    if (user.credits > 0 || user.estimatorCredits > 0) {
      setShowCredits(true);
    }
  }, [user]);

  const currentPath = window.location.pathname;
  const isLandingPage = currentPath === '/';
  const isHomePage =
    !dashboardState.showPricingDashboard &&
    (currentPath === '/' || currentPath === '/airbnb-data' || currentPath === '/airbnb-data/');

  // Open Tawk.to widget
  const openChat = () => {
    const tawkURL = 'https://tawk.to/chat/5f42ecee1e7ade5df4434438/default';
    const win = window.open(tawkURL, '_blank');
    win && win.focus();

    // the below code is not working anymore
    const _window: any = window;
    const Tawk_API = _window.Tawk_API || {};
    Tawk_API && Tawk_API.popup && Tawk_API.popup();
  };

  return (
    <>
      <Grid
        item
        container
        spacing={1}
        justifyContent="flex-end"
        alignItems="center"
        className={classes.container}
      >
        {/* {!sidebarOpen && (
          <Typography variant="caption" color="textPrimary" className={classes.creditsText}>
            <InfoTooltip
              title={
                <TooltipCard
                  content={
                    dashboardState.showEstimatorDashboard
                      ? 'Access full comps and data for an address using 1 estimator credit.'
                      : 'It gives access to one market dashboard per credit.'
                  }
                />
              }
            >
              <div id="creditsBtn" style={{ minWidth: '180px' }}>
                {' '}
                {dashboardState.showEstimatorDashboard ? 'Estimator' : 'Market'} Credits:{' '}
                {dashboardState.showEstimatorDashboard ? user.estimatorCredits : user.credits}{' '}
                <IconButton className={classes.iconButton} onClick={handleSubscriptionModalOpen}>
                  <AddIcon className={classes.addCreditsBtn} />
                </IconButton>
              </div>
            </InfoTooltip>
          </Typography>
        )} */}

        {/* {!matches &&
          (dashboardState.showDiscoveryDashboard ||
            dashboardState.showInsightsDashboard ||
            isHomePage) && (
            <Button
              onClick={() => {
                updateShowAppTour(true);
              }}
              size="large"
              className={clsx(classes.takeTour)}
            >
              <TourIcon />
              <span style={{ paddingLeft: '5px' }}>Take Tour</span>
            </Button>
          )} */}

        {/* <CurrencyChangeMenu currency={currency} setCurrency={setCurrency} /> */}

        {!filterOpen &&
          !isHomePage &&
          (dashboardState.showPricingDashboard ||
            dashboardState.showGuestsDashboard ||
            dashboardState.showHistoricalDashboard) && (
            <Button
              id="filterButton"
              className={clsx(classes.customButtonActive, {
                [classes.customButtonActive]: dashboardState.showInsightsDashboard && filterApplied,
                [classes.customButton]: dashboardState.showInsightsDashboard && !filterApplied,
              })}
              aria-label="open drawer"
              onClick={toggleDrawer}
            >
              <FilterListIcon />
              {dashboardState.showPricingDashboard ? 'Create CompSet' : 'Filters'}
            </Button>
          )}

        {currentPath.includes('/airbnb-data') &&
          !currentPath.includes(
            '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove'
          ) && (
            // <UnlockCTAButton
            //   handleClick={() =>
            //     window.open(
            //       '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove',
            //       '_self'
            //     )
            //   }
            //   text={'View Demo Market'}
            //   invert={true}
            // />
            <Button
              variant="outlined"
              onClick={() => {
                window.open(
                  '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove',
                  '_self'
                );
              }}
              style={{
                border: `2px solid ${KPI_CARD_COLOR}`,
                color: KPI_CARD_COLOR,
                marginRight: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body2">View Demo Market</Typography>
            </Button>
          )}
        {!showCredits && (
          <Typography
            variant="body1"
            className={classes.subscribe}
            onClick={() => {
              if (!isLoggedIn) {
                localStorage.setItem('estimatorCoords', JSON.stringify(centerCoord));
                localStorage.setItem('estimatorAddress', address);
                setLoginModalOpen(true);
              } else {
                handleSubscriptionModalOpen();
                localStorage.setItem('userOpenSubscriptionModalIntentionally', 'true');
              }
            }}
          >
            {isLoggedIn ? 'Subscribe' : 'Start for Free'}
          </Typography>
        )}

        {showCredits && (
          <Typography
            variant="body1"
            onClick={handleSubscriptionModalOpen}
            style={{ display: 'flex', alignItems: 'center', color: '#000' }}
          >
            {dashboardState.showEstimatorDashboard ? 'Estimator' : 'Market'} Credits:{' '}
            <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>
              {dashboardState.showEstimatorDashboard ? user.estimatorCredits : user.credits}
            </span>
            {'   '}
            <InfoTooltip
              title={
                <TooltipCard
                  content={
                    dashboardState.showEstimatorDashboard
                      ? 'Access full comps and data for an address using 1 estimator credit.'
                      : 'It gives access to one market dashboard per credit.'
                  }
                />
              }
            >
              <IconButton
                onClick={() => {
                  setSubscriptionModalOpen(true);
                }}
                sx={{
                  height: 25,
                  width: 25,
                  margin: ' 0px 10px',
                  border: `2px solid ${KPI_CARD_COLOR}`,
                  color: KPI_CARD_COLOR,
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <AddIcon />
              </IconButton>
            </InfoTooltip>
          </Typography>
        )}

        {/* Help Section Added */}
        <Grid item>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 200,
              border: `4px solid ${COLOR_PRIMARY_DARK}`,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <QuestionMarkRoundedIcon
              sx={{
                width: 30,
                height: 30,
                cursor: 'pointer',
                color: KPI_CARD_COLOR,
              }}
              onClick={handleHelperClick}
            />
          </Box>

          <Menu
            anchorEl={helperEl}
            getContentAnchorEl={null}
            open={Boolean(helperEl)}
            onClose={handleHelperClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            className={classes.customMenu}
          >
            <MenuItem onClick={openChat}>
              <SupportAgentIcon sx={{ marginRight: '3px' }} />
              Support
            </MenuItem>
            <MenuItem>
              <Link
                href="https://support.airbtics.com/"
                target="_blank"
                style={{ textDecoration: 'none', color: COLOR_BLACK, display: 'flex' }}
              >
                <QuestionAnswerIcon sx={{ marginRight: '3px' }} />
                FAQ
              </Link>
            </MenuItem>
            <MenuItem>
              <List
                sx={{ padding: 0, width: '100%', color: COLOR_BLACK }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton onClick={handleEnterpriseDropdownClick} sx={{ padding: 0 }}>
                  <ListItemIcon sx={{ minWidth: '10px' }}>
                    <BusinessRoundedIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                  </ListItemIcon>
                  <ListItemText primary="Enterprise" />
                  {enterpriseDropDownOpen ? (
                    <ExpandMore />
                  ) : (
                    <ArrowForwardIosIcon sx={{ fontSize: '15px', fontWeight: 500 }} />
                  )}
                </ListItemButton>
                <Collapse in={enterpriseDropDownOpen} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    sx={{ padding: 0, borderLeft: '0.5px solid lightgrey', marginLeft: '10px' }}
                    onClick={() => {
                      setEnterpriseDropDownOpen(false);
                      window.open('https://wll5z0jqe4c.typeform.com/to/t9O80SZ2', '_blank');
                      postOnSlack(
                        'C05JDGPMH8T',
                        `User: ${user.email} clicked on Custom Data Button In the App Header`
                      );
                    }}
                  >
                    <ListItemButton>
                      <ListItemIcon sx={{ minWidth: '10px' }}>
                        <DataObjectIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                      </ListItemIcon>
                      <ListItemText primary="Custom Data" />
                    </ListItemButton>
                  </List>
                  <List
                    component="div"
                    sx={{ padding: 0 }}
                    onClick={() => {
                      setEnterpriseDropDownOpen(false);
                      window.open(
                        'https://documenter.getpostman.com/view/25155751/2s9XxtyvNn',
                        '_blank'
                      );
                      postOnSlack(
                        'C05JDGPMH8T',
                        `User: ${user.email} clicked on API Button In the App Header`
                      );
                    }}
                  >
                    <ListItemButton>
                      <ListItemIcon
                        sx={{
                          minWidth: '10px',
                          borderLeft: '0.5px solid lightgrey',
                          marginLeft: '10px',
                        }}
                      >
                        <ApiIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                      </ListItemIcon>
                      <ListItemText primary="API" />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </MenuItem>
            <MenuItem>
              <List
                sx={{ padding: 0, width: '100%', color: COLOR_BLACK }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton onClick={handleManageDropdownClick} sx={{ padding: 0 }}>
                  <ListItemIcon sx={{ minWidth: '10px' }}>
                    <GroupsIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                  </ListItemIcon>
                  <ListItemText primary="Manage my listing" />
                  {manageDropDownOpen ? (
                    <ExpandMore />
                  ) : (
                    <ArrowForwardIosIcon sx={{ fontSize: '15px', fontWeight: 500 }} />
                  )}
                </ListItemButton>
                <Collapse in={manageDropDownOpen} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    sx={{
                      padding: 0,
                      borderLeft: '0.5px solid lightgrey',
                      marginLeft: '10px',
                    }}
                    onClick={() => {
                      setManageDropDownOpen(false);
                      setHelperEl(null);
                      handleSidebarListItemClick(7);
                      handleMarketSidebarClick('listings');
                      window.history.pushState({}, '', '/pricing');
                    }}
                  >
                    <ListItemButton>
                      <ListItemIcon sx={{ minWidth: '10px' }}>
                        <MoneyIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                      </ListItemIcon>
                      <ListItemText primary="Dynamic Pricing" />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </MenuItem>
          </Menu>
        </Grid>

        <Grid item>
          <Avatar
            className={classes.avatar}
            onClick={handleClick}
            src={userNameInitials == '' ? userIcon : ''}
          >
            {userNameInitials}
          </Avatar>

          <Menu
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            className={classes.customMenu}
          >
            <MenuItem onClick={openSettings}>
              <AccountCircleIcon sx={{ marginRight: '3px' }} />
              Your Account
            </MenuItem>
            <MenuItem onClick={handleLoginLogout}>
              <LogoutIcon sx={{ marginRight: '3px' }} />
              {isLoggedIn ? 'Log out' : 'Log In'}
            </MenuItem>
            <MenuItem style={{ padding: '0px' }}>
              <CurrencyChangeMenu currency={currency} setCurrency={setCurrency} fullWidth={true} />
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>

      {/* Mobile UI */}
      {matches && isMobileSearchBarOpen && (
        <Grid xs={12} style={{ width: '100%' }}>
          {SearchBar}
        </Grid>
      )}
      {!isMobileSearchBarOpen && (
        <Grid
          item
          container
          justifyContent="space-between"
          alignItems="center"
          className={classes.mobileHeader}
        >
          <Grid item>
            <Button onClick={() => setSidebarOpen(true)}>
              <MenuIcon className={classes.menuIcon} />
            </Button>

            <Button>
              <img src={logoMobile} className={classes.logoMobile} />
            </Button>
          </Grid>

          {/* Help Section Added */}
          <Grid item>
            <Grid
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              {/* Search Section */}
              <Grid item>
                <Box
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: 200,
                    border: `4px solid ${COLOR_PRIMARY_DARK}`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: '5px',
                    background: COLOR_PRIMARY_DARK,
                  }}
                >
                  <SearchRoundedIcon
                    sx={{
                      width: 30,
                      height: 30,
                      cursor: 'pointer',
                      color: '#fff',
                    }}
                    onClick={() => setIsMobileSearchBarOpen(true)}
                  />
                </Box>
              </Grid>

              <Grid item>
                <Box
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: 200,
                    border: `4px solid ${COLOR_PRIMARY_DARK}`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: '5px',
                  }}
                >
                  <QuestionMarkRoundedIcon
                    sx={{
                      width: 30,
                      height: 30,
                      cursor: 'pointer',
                      color: KPI_CARD_COLOR,
                    }}
                    onClick={handleHelperClick}
                  />
                </Box>

                <Menu
                  anchorEl={helperEl}
                  getContentAnchorEl={null}
                  open={Boolean(helperEl)}
                  onClose={handleHelperClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  className={classes.customMenu}
                >
                  <MenuItem onClick={openChat}>
                    <SupportAgentIcon sx={{ marginRight: '3px' }} />
                    Support
                  </MenuItem>
                  <MenuItem>
                    <Link
                      href="https://support.airbtics.com/"
                      target="_blank"
                      style={{ textDecoration: 'none', color: COLOR_BLACK, display: 'flex' }}
                    >
                      <QuestionAnswerIcon sx={{ marginRight: '3px' }} />
                      FAQ
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <List
                      sx={{ padding: 0, width: '100%', color: COLOR_BLACK }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                    >
                      <ListItemButton onClick={handleEnterpriseDropdownClick} sx={{ padding: 0 }}>
                        <ListItemIcon sx={{ minWidth: '10px' }}>
                          <BusinessRoundedIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                        </ListItemIcon>
                        <ListItemText primary="Enterprise" />
                        {enterpriseDropDownOpen ? (
                          <ExpandMore />
                        ) : (
                          <ArrowForwardIosIcon sx={{ fontSize: '15px', fontWeight: 500 }} />
                        )}
                      </ListItemButton>
                      <Collapse in={enterpriseDropDownOpen} timeout="auto" unmountOnExit>
                        <List
                          component="div"
                          sx={{
                            padding: 0,
                            borderLeft: '0.5px solid lightgrey',
                            marginLeft: '10px',
                          }}
                          onClick={() => {
                            setEnterpriseDropDownOpen(false);
                            window.open('https://wll5z0jqe4c.typeform.com/to/t9O80SZ2', '_blank');
                            postOnSlack(
                              'C05JDGPMH8T',
                              `User: ${user.email} clicked on Custom Data Button In the App Header`
                            );
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon sx={{ minWidth: '10px' }}>
                              <DataObjectIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                            </ListItemIcon>
                            <ListItemText primary="Custom data" />
                          </ListItemButton>
                        </List>
                        <List
                          component="div"
                          sx={{
                            padding: 0,
                            borderLeft: '0.5px solid lightgrey',
                            marginLeft: '10px',
                          }}
                          onClick={() => {
                            setEnterpriseDropDownOpen(false);
                            window.open(
                              'https://documenter.getpostman.com/view/25155751/2s9XxtyvNn',
                              '_blank'
                            );
                            postOnSlack(
                              'C05JDGPMH8T',
                              `User: ${user.email} clicked on API Button In the App Header`
                            );
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon sx={{ minWidth: '10px' }}>
                              <ApiIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                            </ListItemIcon>
                            <ListItemText primary="API" />
                          </ListItemButton>
                        </List>
                      </Collapse>
                    </List>
                  </MenuItem>
                  <MenuItem>
                    <List
                      sx={{ padding: 0, width: '100%', color: COLOR_BLACK }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                    >
                      <ListItemButton onClick={handleManageDropdownClick} sx={{ padding: 0 }}>
                        <ListItemIcon sx={{ minWidth: '10px' }}>
                          <GroupsIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                        </ListItemIcon>
                        <ListItemText primary="Manage my listing" />
                        {manageDropDownOpen ? (
                          <ExpandMore />
                        ) : (
                          <ArrowForwardIosIcon sx={{ fontSize: '15px', fontWeight: 500 }} />
                        )}
                      </ListItemButton>
                      <Collapse in={manageDropDownOpen} timeout="auto" unmountOnExit>
                        <List
                          component="div"
                          sx={{
                            padding: 0,
                            borderLeft: '0.5px solid lightgrey',
                            marginLeft: '10px',
                          }}
                          onClick={() => {
                            setManageDropDownOpen(false);
                            setHelperEl(null);
                            handleSidebarListItemClick(7);
                            handleMarketSidebarClick('listings');
                            window.history.pushState({}, '', '/pricing');
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon sx={{ minWidth: '10px' }}>
                              <MoneyIcon sx={{ color: COLOR_BLACK, paddingRight: '5px' }} />
                            </ListItemIcon>
                            <ListItemText primary="Dynamic Pricing" />
                          </ListItemButton>
                        </List>
                      </Collapse>
                    </List>
                  </MenuItem>
                </Menu>
              </Grid>

              <Grid item>
                <Avatar
                  className={classes.avatar}
                  onClick={handleClick}
                  src={userNameInitials == '' ? userIcon : ''}
                >
                  {userNameInitials}
                </Avatar>

                <Menu
                  anchorEl={anchorEl}
                  getContentAnchorEl={null}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  className={classes.customMenu}
                >
                  <MenuItem onClick={openSettings}>
                    <AccountCircleIcon sx={{ marginRight: '3px' }} />
                    Your Account
                  </MenuItem>
                  <MenuItem onClick={handleLoginLogout}>
                    <LogoutIcon sx={{ marginRight: '3px' }} />
                    {isLoggedIn ? 'Log out' : 'Log In'}
                  </MenuItem>
                  <MenuItem style={{ padding: '0px' }}>
                    <CurrencyChangeMenu
                      currency={currency}
                      setCurrency={setCurrency}
                      fullWidth={true}
                    />
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default TopRibbon;
